import AddContentChild from './AddContentChild';

export default AddContentChild;
